export default __webpack_public_path__ + "static/media/mu.562726ed.svg";